<ca-card ui-3 class="mt-4 md-5" *ngIf="version" >
    <div ca-card-title>{{'AUTOS.SIMULAR.TITULO' | translate}}</div>
    <div ca-card-content>
        <form *ngIf="simularForm" [formGroup]="simularForm" (ngSubmit)="tarificar()" >
            <ca-card ui-3 class="mb-3 center" *ngIf="poliza?.recibo && !simularForm.invalid">
                <div ca-card-content>
                    <div class="precios-container">
                        <app-tarificacion 
                                [recibo]="poliza?.recibo"
                                (contratarEmitter)="contratarPoliza($event)"></app-tarificacion>
                    </div>
                </div>
            </ca-card>

            <ca-card ui-3 *ngIf="catalogo?.preguntas?.length>0">
                <div ca-card-title>{{'AUTOS.SIMULAR.USO_VEHICULO.TITULO' | translate}}</div>
                <div ca-card-content>
                    <div formGroupName="usoVehiculo">
                        <app-uso-vehiculo 
                            [preguntasCatalogo]="catalogo?.preguntas"
                            [preguntasPoliza]="riesgoCarga?.preguntas"
                            [version]="version"
                            [auto]="auto"
                            [form]="simularForm.get('usoVehiculo')"></app-uso-vehiculo>
                    </div>
                </div>
            </ca-card>

            <ca-card ui-3 class="mt-3" *ngIf="tomadorConfig && domicilioTomadorConfig">
                <div ca-card-title>{{'COMUN.DATOS_GENERALES.TITULO' | translate}} {{'COMUN.DATOS_PERSONA.TIPO_PERSONA.TOMADOR' | translate}}</div>
                <div ca-card-content>  
                    <div formGroupName="datosPersonalesTomador">                
                        <app-datos-personales
                            [config]="tomadorConfig" 
                            [form]="simularForm.get('datosPersonalesTomador')"
                            (personaChange)="onTomadorChange($event)"></app-datos-personales>     
                    </div>
                    <div formGroupName="datosDomicilioTomador" class="mt-2">
                        <app-datos-domicilio 
                            [config]="domicilioTomadorConfig" 
                            [form]="simularForm.get('datosDomicilioTomador')"
                            (domicilioChange)="onDomicilioTomadorChange($event)"></app-datos-domicilio> 
                    </div>
                    <div class="mt-3 col-4">
                        <ca-radio-group  
                            id="radio_intervinientes" 
                            name="radio_intervinientes" 
                            [value]="mostrarOtrosIntervinientes ? '2' : '1'"
                             (change)="cambioIntervinientes($event)">
                            <ca-radio-button value="1" >{{'AUTOS.SIMULAR.INTERVINIENTES.RADIO_TOMADOR' | translate}}</ca-radio-button>
                            <ca-radio-button value="2" >{{'AUTOS.SIMULAR.INTERVINIENTES.RADIO_OTROS' | translate}}</ca-radio-button>
                        </ca-radio-group>  
                    </div>
                </div>
            </ca-card>     

            <ca-card ui-3 class="mt-3" *ngIf="mostrarOtrosIntervinientes && propietarioConfig">
                <div ca-card-title>{{'COMUN.DATOS_GENERALES.TITULO' | translate}} {{'COMUN.DATOS_PERSONA.TIPO_PERSONA.PROPIETARIO' | translate}}</div>
                <div ca-card-content>  
                    <div formGroupName="datosPersonalesPropietario">                
                        <app-datos-personales 
                            [config]="propietarioConfig" 
                            [form]="simularForm.get('datosPersonalesPropietario')"
                            (personaChange)="onPropietarioChange($event)"></app-datos-personales>     
                    </div>
                </div>
            </ca-card>  

            <ca-card ui-3 class="mt-3" *ngIf="catalogo?.preguntas?.length>0">
                <div ca-card-title>{{'COMUN.DATOS_GENERALES.TITULO' | translate}} {{'COMUN.DATOS_PERSONA.TIPO_PERSONA.CONDUCTOR' | translate}}</div>
                <div ca-card-content>  
                    <div formGroupName="datosPersonalesConductor" *ngIf="mostrarOtrosIntervinientes && conductorConfig">                
                        <app-datos-personales 
                            [config]="conductorConfig" 
                            [form]="simularForm.get('datosPersonalesConductor')"
                            (personaChange)="onConductorChange($event)"></app-datos-personales>     
                    </div>
                    <div formGroupName="datosObligatoriosConductor"> 
                        <app-datos-conductor
                            [preguntasPoliza]="riesgoCarga?.preguntas"
                            [preguntasCatalogo]="catalogo?.preguntas"
                            [form]="simularForm.get('datosObligatoriosConductor')"></app-datos-conductor>
                    </div>
                </div>
            </ca-card>  
           
            <ca-card ui-3 class="mt-3" *ngIf="catalogo?.coberturas?.length>0">
                <div ca-card-title>{{'CATALOGO.COBERTURAS.TITULO' | translate}}</div>
                <div ca-card-content>  
                    <div formGroupName="coberturas"> 
                        <app-coberturas
                            [coberturasPoliza]="riesgoCarga?.coberturas"
                            [coberturasCatalogo]="catalogo?.coberturas"
                            [form]="simularForm.get('coberturas')"></app-coberturas>
                    </div>
                </div>
            </ca-card> 

            <ca-card ui-3 class="mt-3" *ngIf="catalogo?.fraccionamientos.length>0">
                <div ca-card-title>{{'CATALOGO.DATOS_ADICIONALES.TITULO' | translate}}</div>
                <div ca-card-content>  
                    <div formGroupName="datosAdicionales"> 
                        <app-datos-adicionales
                            [poliza]="poliza"
                            [fraccionamientos]="catalogo?.fraccionamientos"
                            [form]="simularForm.get('datosAdicionales')"></app-datos-adicionales>
                    </div>
                </div>
            </ca-card> 

            <div class="mt-4 pb-4">
                <div class="float-left">
                    <button ca-button-secondary type="button" (click)="volverSimulacion()" >            
                        <ca-icon>chevron_left</ca-icon>
                        {{'MAIN.BOTON_VOLVER' | translate}}
                    </button>
                </div> 
                <div class="float-right">
                    <button ca-button class="ca-btn-icon__container ml-2" type="submit"
                        [disabled]="simularForm.invalid">
                        {{'AUTOS.SIMULAR.BOTON_SIMULAR' | translate}}                        
                    </button>
                    <button ca-button class="ca-btn-icon__container ml-2" type="button"
                        (click)="guardarProyecto()"
                        [disabled]="simularForm.invalid || !poliza?.recibo">
                        {{'MENU.PRIVADO.GUARDAR' | translate}}                        
                    </button>
                </div>  
            </div>
        </form>
    </div>
</ca-card>
